import InputNumber from './InputNumber';
export default InputNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-input-number/es/index.js
// module id = 942
// module chunks = 0